import { JetpacB2BApi } from 'api' // NOTE: Assuming a B2B-specific API client exists. Please replace with the correct one.

class TenantCommercialsApi {
  static async getCommercialsById(faberToken: string, id: string) {
    return JetpacB2BApi.httpGet(
      `tenant-commercial/${id}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }

  static async createTenantCommercials(
    body: ITenantCommercialsBackendData,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPost(
      `tenant-commercial`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }

  static async updateTenantCommercials(
    body: ITenantCommercialsBackendData,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPut(
      `tenant-commercial`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
}

export default TenantCommercialsApi

export interface ITenantCommercialsBackendData {
  tenant_id: string
  commercial_type: string
  credit_terms_period: string
  credit_limit: string
  is_active: boolean
  created_by: string
  updated_by: string
  // This field is only required for update operation
  id?: string
}
